module.exports = __webpack_public_path__ + "kustom.4d8914a87db34479785546e2978695d1.svg";